import { render, staticRenderFns } from "./Terms1920.vue?vue&type=template&id=3ff0140a&scoped=true"
import script from "./Terms1920.vue?vue&type=script&lang=js"
export * from "./Terms1920.vue?vue&type=script&lang=js"
import style0 from "./Terms1920.vue?vue&type=style&index=0&id=3ff0140a&prod&lang=css&scoped=true"
import style1 from "./Terms1920.vue?vue&type=style&index=1&id=3ff0140a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff0140a",
  null
  
)

export default component.exports